










import { Component, Vue, Watch } from 'vue-property-decorator';
import { tagsViewModule } from '@/store/modules/ModuleTagsView';
import { appModule, IForbiddenData } from '@/store/modules/ModuleApp';
import { FORBIDDEN_CONFIG_REDIRECT, FORBIDDEN_PAGE, getLastInvokeUserKey, SECOND_HOME_PAGE, TEMP_PERMISSION_URL } from '@/libs/LibsStatus';
import { setLocalStorage } from '@tencent/s2-client-vue-lib';
import { IUserData, userModule } from '@/store/modules/ModuleUser';

@Component({
	name: 'AppMain'
})
/** app main */
export default class extends Vue {
	/** document hooks */
	public get cachedViews(): any {
		return tagsViewModule.cachedViews;
	}

	/** document hooks */
	public get key(): any {
		return this.$route.path;
	}

	/** 监测是否有AJAX返回403，如果返回，显示403 */
	public get forbiddenChange(): IForbiddenData {
		return appModule.forbiddenChange;
	}

	/** 用户数据 */
	public get userData(): IUserData {
		return userModule.userData;
	}

	/** 当前选中行更新 */
	@Watch('forbiddenChange', { immediate: true, deep: true })
	public selectedRowsvalUpdate(val: IForbiddenData, old: IForbiddenData): void {
		console.log(val);
		if (val && val.isForbidden) {
			const redirect = val.error?.error?.config?.headers?.[FORBIDDEN_CONFIG_REDIRECT] ?? true;
			// 是否重定向到403页面
			// 跳转至403
			// const replaceParams: any = this.$route.path.split('/').slice(1);
			// this.$router.push({
			// 	name: 'NotFound',
			// 	params: { pathMatch: replaceParams },
			// 	query: this.$route.query,
			// 	hash: this.$route.hash
			// });
			// TIPS传统方案
			const currentUrl = window.location.pathname;
			if (currentUrl !== FORBIDDEN_PAGE && currentUrl !== SECOND_HOME_PAGE && redirect) {
				const replaceUrl = getLastInvokeUserKey(TEMP_PERMISSION_URL, this.userData);
				setLocalStorage(replaceUrl, window.location.href);
				const loc: any = this.$router.resolve({ path: '/403' });
				window.location.href = loc.href;
			}
		}
	}
}
